export const spots = [
  { slug: "tokyo", imgUrl: "/spots/locations/tokyo.png" },
  { slug: "mt-fuji", imgUrl: "/spots/locations/mt-fuji.png" },
  { slug: "nagoya", imgUrl: "/spots/locations/nagoya.png" },
  { slug: "kyoto", imgUrl: "/spots/locations/kyoto.png" },
  { slug: "nara", imgUrl: "/spots/locations/nara.png" },
  { slug: "osaka", imgUrl: "/spots/locations/osaka.png" },
  { slug: "kobe", imgUrl: "/spots/locations/kobe.png" },
  { slug: "hiroshima", imgUrl: "/spots/locations/hiroshima.png" },
  { slug: "fukuoka", imgUrl: "/spots/locations/fukuoka.png" },
  { slug: "okinawa", imgUrl: "/spots/locations/okinawa.png" },
  { slug: "nikko", imgUrl: "/spots/locations/nikko.png" },
  { slug: "hokkaido", imgUrl: "/spots/locations/hokkaido.png" },
  { slug: "miyajima", imgUrl: "/spots/locations/miyajima.png" },
  { slug: "takayama", imgUrl: "/spots/locations/takayama.png" },
  { slug: "takamatsu", imgUrl: "/spots/types/culture.png" },
  { slug: "naoshima", imgUrl: "/spots/locations/naoshima.png" },
  { slug: "hakone", imgUrl: "/spots/locations/hakone.png" },
  { slug: "saitama", imgUrl: "/spots/locations/saitama.png" },
  { slug: "niigata", imgUrl: "/spots/locations/niigata.png" },
  { slug: "kawasaki", imgUrl: "/spots/locations/kawasaki.png" },
  { slug: "shizuoka", imgUrl: "/spots/locations/shizuoka.png" },
  { slug: "yokohama", imgUrl: "/spots/locations/yokohama.png" },
  { slug: "kanazawa", imgUrl: "/spots/locations/kanazawa.png" },
  { slug: "nagano", imgUrl: "/spots/types/outdoor.png" },
  { slug: "tsumago", imgUrl: "/spots/locations/tsumago.png" },
  { slug: "matsue", imgUrl: "/spots/types/private.png" },
  { slug: "magome", imgUrl: "/spots/types/outdoor.png" },
  { slug: "fujikawaguchiko", imgUrl: "/spots/locations/mt-fuji.png" },
  { slug: "kumano-kodo", imgUrl: "/spots/locations/kumano-kodo.png" },
  { slug: "beppu", imgUrl: "/spots/types/private.png" },
  { slug: "kagoshima", imgUrl: "/spots/types/private.png" },
  { slug: "himeji", imgUrl: "/spots/types/private.png" },
  { slug: "fukuyama", imgUrl: "/spots/types/private.png" },
] as const;

export const locationIconMap = new Map(
  spots.map((location) => [location.slug, location.imgUrl]),
);

export function getLocationIcon(location: string) {
  return isLocationSlug(location)
    ? locationIconMap.get(location)
    : "/spots/types/private.png";
}

export function isLocationSlug(slug: string): slug is LocationSlug {
  return spots.some((spot) => spot.slug === slug);
}

export type LocationSlug = (typeof spots)[number]["slug"];
